import { db, auth } from "../firebase/firebase.js";
import {
  doc,
  query,
  collection,
  where,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
} from "firebase/firestore";

export const fetchLastResetTime = async (uid) => {
  const timerDocRef = doc(db, "timestamps", uid);
  const docSnap = await getDoc(timerDocRef);
  return docSnap.exists() ? docSnap.data().lastResetTime.toDate() : null;
};

export const updateLastResetTime = async (uid) => {
  const timerDocRef = doc(db, "timestamps", uid);
  await setDoc(timerDocRef, { lastResetTime: new Date() });
};

export const setLastUpdated = async (agentId, uid) => {
  const agentDocRef = doc(db, "users", uid, "agents", agentId);
  await updateDoc(agentDocRef, { lastResetTime: new Date() });
};

export const lastUpdatedPlus = async (agentId, spacing, uid) => {
  const agentDocRef = db
    .collection("users")
    .doc(uid)
    .collection("agents")
    .doc(agentId);
  const nextTime = new Date(Date.now() + spacing * 60000);
  await agentDocRef.update({ lastResetTime: nextTime });
};

// Convert duration (minutes) to Date object
export const durationToDate = (durationMinutes) => {
  const date = new Date(0);
  const hours = Math.floor(durationMinutes / 60);
  const minutes = durationMinutes % 60;
  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};

// Convert Date object to duration (minutes)
export const dateToDuration = (date) => {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return hours * 60 + minutes;
};
